module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-blog-single ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (!_vm.loading) ? _c('main', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-content"
  }, [_c('div', {
    staticClass: "ccm-block-page-title-byline"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }), _c('span', {
    staticClass: "page-date"
  }, [_vm._v(_vm._s(_vm.props.acf.date_in_all))]), _c('span', {
    staticClass: "page-author"
  }, [_vm._v(_vm._s(_vm.props.acf.author_all))])]), _c('div', {
    staticClass: "single-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-3 col-sidebar"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-sidebar-11 block-sidebar-wrapped"
  }, [_c('div', {
    staticClass: "ccm-block-next-previous-wrapper"
  }, [(_vm.props.acf.previous_post) ? _c('div', {
    staticClass: "ccm-block-next-previous-header"
  }, [_c('h5', [_vm._v("Last Post")])]) : _vm._e(), (_vm.props.acf.previous_post) ? _c('p', {
    staticClass: "ccm-block-next-previous-previous-link"
  }, [_c('a', {
    attrs: {
      "href": "/blog/" + _vm.props.acf.previous_post.post_name
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.previous_post.post_title)
    }
  })]) : _vm._e(), (_vm.props.acf.next_post) ? _c('div', {
    staticClass: "ccm-block-next-previous-header"
  }, [_c('h5', [_vm._v("Next Post")])]) : _vm._e(), (_vm.props.acf.next_post) ? _c('p', {
    staticClass: "ccm-block-next-previous-next-link"
  }, [_c('a', {
    attrs: {
      "href": "/blog/" + _vm.props.acf.next_post.post_name
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.next_post.post_title)
    }
  })]) : _vm._e()])]), _c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-sidebar-12 block-sidebar-wrapped"
  }, [_c('div', {
    staticClass: "ccm-block-share-this-page"
  }, [_c('social-sharing', {
    attrs: {
      "url": "https://updikeortho.com/blog/" + _vm.props.slug,
      "title": _vm.props.title.rendered,
      "description": _vm.props.excerpt.rendered,
      "hashtags": "updikeortho",
      "twitter-user": "updikeortho"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('ul', {
            staticClass: "list-inline"
          }, [_c('li', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          })])], 1), _c('li', [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          })])], 1), _c('li', [_c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-linkedin-square"
          })])], 1), _c('li', [_c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-envelope"
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  })], 1)]), _vm._m(0)])])]), _c('div', {
    staticClass: "saprater-mian"
  })]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-block-page-list-wrapper"
  }, [_c('div', {
    staticClass: "ccm-block-page-list-header"
  }, [_c('h5', [_vm._v("Related Posts")])]), _c('div', {
    staticClass: "ccm-block-page-list-pages"
  }), _c('div', {
    staticClass: "ccm-block-page-list-no-pages"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bdf163e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog-post/blog-post.pug
// module id = 561
// module chunks = 1